import { dialog } from "../../../nq-component";
import BaseFormPresenter from "../../../base/BaseFormPresenter";
import DialogSuccess from "../components/DialogSuccess";
import { generateOnboardEmail } from "./utils/utils";
import { restUseCase } from "../../../usecases/rest";

class DashboardFormPagePresenter extends BaseFormPresenter {
  constructor(
    view,
    upsertUseCase,
    getObjectUseCase,
    findObjectUseCase,
    deleteObjectUseCase
  ) {
    super();
    this.view = view;
    this.upsertUseCase = upsertUseCase;
    this.getObjectUseCase = getObjectUseCase;
    this.findObjectUseCase = findObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
  }

  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  componentDidMount() {
    this.init();
    this.getObject();
    this.getOnBoard();
  }

  async handleClickApprove() {
    const collection = this.view.getCollectionName();
    const today = new Date()
      .toLocaleString("sv-SE", { timeZone: "Asia/Manila" })
      .replace(" ", "T");
    const { remarks, ...datas } = this.object;
    let application = {
      ...datas,
      recruiter: {
        id: datas.recruiter?.id,
      },
      applicant: {
        id: datas.applicant?.id,
      },
      coordinator: {
        id: datas.coordinator?.id,
      },

      docs1: false,
      docs2: false,
      docs3: false,
      docs4: false,
      docs5: false,
      onBoardRemarks: "",
      hireDate: today,
    };
    try {
      const removeApplication = await this.deleteObjectUseCase.execute(
        collection,
        this.object?.id
      );

      const approveApplication = await this.upsertUseCase.execute(
        collection,
        application
      );

      dialog.close();
      this.view.setState({ object: approveApplication });
      this.object = approveApplication;
      dialog.fire({
        html: <DialogSuccess message={"Approved Successfully!"} />,
        footer: false,
      });
    } catch (error) {
      console.log(error);
      this.view.showError(error);
    }
  }

  async handleClickReject() {
    const collection = this.view.getCollectionName();
    const remarks = this.view.state.remarks;
    const { recruiter, coordinator, ...updatedObject } = this.object;

    updatedObject.status = "For Interview";
    updatedObject.recruiter = { id: this.object.recruiter?.id };
    updatedObject.applicant = { id: this.object.applicant?.id };
    updatedObject.remarks = remarks;

    try {
      const removeApplication = await this.deleteObjectUseCase.execute(
        collection,
        this.object?.id
      );

      const rejectApplication = await this.upsertUseCase.execute(
        collection,
        updatedObject
      );

      dialog.close();
      this.view.setState({ object: rejectApplication });
      this.view.navigateTo("/coordinator/for-interview");
      dialog.fire({
        html: <DialogSuccess message={"Reject Successfully!"} />,
        footer: false,
      });
    } catch (error) {
      console.log(error);
      this.view.showError(error);
    }
  }

  async handleAddStartDate(startDate) {
    const collection = this.view.getCollectionName();
    const { ...datas } = this.object;
    console.log(datas);
    let application = {
      ...datas,
      recruiter: {
        id: datas.recruiter?.id,
      },
      applicant: {
        id: datas.applicant?.id,
      },
      coordinator: {
        id: datas.coordinator?.id,
      },
      status: "For Endorsement",
      startDate: startDate,
    };
    try {
      const approveApplication = await this.upsertUseCase.execute(
        collection,
        application
      );

      dialog.close();
      this.view.setState({ object: approveApplication });
      this.object = approveApplication;
      dialog.fire({
        html: <DialogSuccess message={"Data Saved Successfully!"} />,
        footer: false,
      });
    } catch (error) {
      console.log(error);
      this.view.showError(error);
    }
  }

  onClickPrint() {
    this.view.exportPDF();
  }

  async getOnBoard() {
    const user = this.view.getCurrentUser();
    const recruiterId = this.view.getRecruiterId();
    const now = new Date();
    const utcMidnight = new Date(now.getTime() + 8 * 60 * 60 * 1000);
    utcMidnight.setUTCHours(0, 0, 0, 0);

    const todayISO = utcMidnight.toISOString();
    const collection = "on_boarding";
    const query = {
      // where: { "recruiter.id": recruiterId },
      where: { assignedDate: { $gt: todayISO } },
    };

    try {
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);

      this.view.setState({ onBoards: objects });
    } catch (error) {
      console.error("Error in findObjects:", error);
      this.view.showError(error);
    } finally {
      this.progress = false;
    }
  }

  showImage() {
    dialog.fire({
      html: (
        <>
          <div className="d-flex justify-content-center mt-2">
            <img
              src="/emailLoading2.gif"
              alt="loading"
              style={{ width: "200px", height: "200px" }}
            />
          </div>
          <div className="text-center mt-3">
            <p style={{ color: "#D18237" }}>Sending email... Please wait...</p>
          </div>
        </>
      ),
      footer: false,
    });
  }

  async sendOnboardEmail(firstname, date, time, getApplicantEmail) {
    const method = "POST";
    const path = "/send-email/d16bcf82-2a04-4eb0-bff8-139d65a4ae56";

    const obj = {
      to: getApplicantEmail,
      subject:
        "Onboarding Schedule and Instructions – LGS Staff Management Services Inc.",
      body: generateOnboardEmail(firstname, date, time),
    };

    try {
      this.showImage();
      const response = await restUseCase().execute(method, path, { body: obj });

      if (response) {
        dialog.close();
        this.view.setState({ object: this.object });
        this.view.successModal(response.message);
      }
    } catch (error) {
      console.error("Error sending email:", error);
    }
  }

  async handleClickOnboard(startDateTime, endDateTime, dateAssigned) {
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();
    const applicantId = this.object.id || this.view.getObjectId();
    const getApplicantEmail =
      this.object?.email || this.object?.applicant?.email;
    const firstName = this.object?.firstName;
    const startTimeFormatted = new Date(startDateTime).toLocaleTimeString(
      "en-US",
      {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      }
    );

    const endTimeFormatted = new Date(endDateTime).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    const formattedDate = new Date(dateAssigned).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    const dateStr = `${startTimeFormatted} - ${endTimeFormatted}`;
    if (!applicantId) return;

    this.object.onBoardStartTime = startDateTime;
    this.object.onBoardEndTime = endDateTime;
    this.object.status = "On-boarding";

    this.object.applicant = {
      id: this.object?.applicant?.id,
    };
    this.object.recruiter = {
      id: this.object?.recruiter?.id,
    };
    this.object.coordinator = {
      id: this.object?.coordinator?.id,
    };
    this.object.interviewForm = {
      id: this.object?.interviewForm?.id,
    };

    delete this.object.applicant.employee;

    try {
      const data = await this.upsertUseCase.execute(collection, this.object);

      if (!data || typeof data !== "object") {
        console.warn("Invalid response data");
        return;
      }

      this.object = data;
      this.sendOnboardEmail(
        firstName,
        formattedDate,
        dateStr,
        getApplicantEmail
      );
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }

  prevInterviewForm() {
    const object = this.object;
    if (object?.prevInterviewForm) {
      this.view.navigateTo(`/interview/form/reprocess/previous/${object?.id}`);
      return;
    }
  }
}

export default DashboardFormPagePresenter;
